
import { IoWarningOutline } from "react-icons/io5";

import Container from "./Container";
import styles from'./empty-styles.module.css'

const EmptyState = ({message}) => {
    return (
        <section className={styles['section-16']}>
            <Container className="py-5">
                <div>
                    <IoWarningOutline className="mb-3" color={'#ff5001'} size={60} />
                    <h4>{message || 'Empty.'}</h4>
                </div>               
            </Container>
        </section>
    );
};

export default EmptyState;